// extracted by mini-css-extract-plugin
module.exports = {"Messages":"ChatMessageArea_Messages__SQKvZ"};